import IconButton from "componentsv2/button/IconButton";
import { SaveIcon, TrashIcon, PaperClipIcon } from "components/Icons";

function attachmentIcon(active, onClick) {
  if (!active) return null;
  return (
    <IconButton
      Icon={PaperClipIcon}
      onClick={() => onClick("attachment")}
      name="button_attachment"
      color="blue"
    />
  );
}

function saveIcon(active, onClick) {
  if (!active) return null;
  return (
    <IconButton
      Icon={SaveIcon}
      onClick={() => onClick("save")}
      name="button_save"
      color="gray"
    />
  );
}

function deleteIcon(active, onClick) {
  if (!active) return null;
  return (
    <IconButton Icon={TrashIcon} onClick={onClick} name="delete" color="rose" />
  );
}

//   button_edit: {
//     icon: (
//       <PencilSquareIcon
//         key={name}
//         className={cn(BTN_STYLE, name, iconColor)}
//       />
//     ),
//   },
//   button_add: {
//     icon: (
//       <PlusCircleIcon key={name} className={cn(BTN_STYLE, name, iconColor)} />
//     ),
//   },

export { saveIcon, deleteIcon, attachmentIcon };
